import { useEffect, useState } from 'react';
import deepEqual from 'deep-equal';

const usePosition = (ref = {}) => {
  const [boundingClientRect, setBoundingClientRect] = useState();

  const element = ref.current;

  useEffect(() => {
    if (element) {
      setBoundingClientRect(element.getBoundingClientRect());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const position = element?.getBoundingClientRect() ?? null;

  if (position && !deepEqual(position, boundingClientRect))
    setBoundingClientRect(position);

  return boundingClientRect;
};

export default usePosition;
